import React, { useCallback } from 'react'
import { Button, Dialog, DialogContent, DialogTitle, Icon, IconButton } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import { gray, purple } from '../../utils/colors'

const OrOptionsDialog = ({
	open,
	onClose,
	title = '',
	mainOptionLabel,
	mainOptionFAIcon = null,
	onMainOptionSelected,
	secondaryOptionLabel,
	secondaryOptionFAIcon = null,
	onSecondaryOptionSelected,
	showSecondaryOption
}) => {
	const classes = useStyles()

	const handleClose = useCallback(() => {
		if (onClose) {
			onClose()
		}
	}, [onClose])

	const handleOnMainOptionSelected = useCallback(() => {
		if (onMainOptionSelected) {
			onMainOptionSelected()
			handleClose()
		}
	}, [onMainOptionSelected, handleClose])

	const handleOnSecondaryOptionSelected = useCallback(() => {
		if (onSecondaryOptionSelected) {
			onSecondaryOptionSelected()
			handleClose()
		}
	}, [onSecondaryOptionSelected, handleClose])

	return (
		<Dialog
			open={open}
			maxWidth="lg"
			onClose={handleClose}
			PaperProps={{
				style: {
					minWidth: '448px',
					maxWidth: '448px',
					width: '448px'
				}
			}}>
			<DialogTitle className={classes.dialogTitle}>
				<div style={{ display: 'flex', flex: 1 }}>
					<div
						style={{
							flex: 1
						}}>
						{title}
					</div>
					<IconButton style={{ padding: 0, flex: 0 }}>
						<Close style={{ color: 'red' }} onClick={handleClose} />
					</IconButton>
				</div>
			</DialogTitle>
			<DialogContent className={classes.contentRoot}>
				<div className={classes.selectionContainer}>
					<Button
						startIcon={
							mainOptionFAIcon ? (
								<Icon
									className={`fal fa-${mainOptionFAIcon}`}
									style={{
										fontWeight: '900',
										fontSize: '16px',
										color: gray[100],
										width: 20
									}}
								/>
							) : null
						}
						variant="contained"
						color="secondary"
						onClick={handleOnMainOptionSelected}>
						{mainOptionLabel}
					</Button>
					{
						showSecondaryOption && (
							<div className={classes.dividerContainer}>
								<div className={classes.divider}></div>
								<div className={classes.orText}>Or</div>
								<div className={classes.divider}></div>
							</div>
						)
					}
					{
						showSecondaryOption && (
							<Button
								startIcon={
									secondaryOptionFAIcon ? (
										<Icon
											className={`fal fa-${secondaryOptionFAIcon}`}
											style={{
												fontWeight: '900',
												fontSize: '16px',
												color: purple[500],
												width: 20
											}}
										/>
									) : null
								}
								variant="text"
								color="secondary"
								onClick={handleOnSecondaryOptionSelected}>
								{secondaryOptionLabel}
							</Button>
						)
					}
				</div>
			</DialogContent>
		</Dialog>
	)
}

const useStyles = makeStyles(() => ({
	contentRoot: {
		padding: '1.625rem 0'
	},
	dialogTitle: {
		textTransform: 'uppercase',
		fontWeight: 600,
		fontSize: '1rem',
		'& .MuiSvgIcon-root': {
			fill: gray[700]
		}
	},
	dialogActions: {
		justifyContent: 'flex-start',
		padding: '0.55rem 0'
	},
	selectionContainer: {
		border: '1.5px solid',
		borderColor: gray[500],
		padding: '1.75rem 2.5rem',
		borderRadius: '0.625rem',
		display: 'flex',
		flexDirection: 'column',
		gap: '1.25rem'
	},
	dividerContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		position: 'relative',
		gap: '1rem'
	},
	divider: {
		height: '1px',
		flex: 1,
		backgroundColor: gray[500]
	},
	orText: {
		textTransform: 'uppercase',
		fontFamily: 'Haboro Soft',
		fontSize: '0.875rem',
		fontWeight: 800
	},
	mainOptionFAIconStyle: {
		fontWeight: '900',
		fontSize: '16px',
		color: gray[100],
		width: 20
	}
}))

export default OrOptionsDialog
